// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEngagementReorderInAppMessagesResult = objectOf({
  priority_bucket: maybe(number),
  priority: maybe(number),
});
